import { Error, Info, ReportProblem, Warning } from '@mui/icons-material';
import { Chip, ChipProps } from '@mui/material';
import React from 'react';
import { DangerLevel } from '../../types/commands';

interface DangerLevelBadgeProps {
  level: DangerLevel;
  size?: 'small' | 'medium';
}

const dangerLevelConfig: Record<
  DangerLevel,
  {
    label: string;
    color: ChipProps['color'];
    icon: React.ReactElement;
    bgcolor: string;
  }
> = {
  low: {
    label: 'Low Risk',
    color: 'success',
    icon: <Info fontSize="small" />,
    bgcolor: '#4caf50',
  },
  medium: {
    label: 'Medium Risk',
    color: 'warning',
    icon: <Warning fontSize="small" />,
    bgcolor: '#ff9800',
  },
  high: {
    label: 'High Risk',
    color: 'error',
    icon: <Error fontSize="small" />,
    bgcolor: '#f44336',
  },
  critical: {
    label: 'Critical',
    color: 'error',
    icon: <ReportProblem fontSize="small" />,
    bgcolor: '#d32f2f',
  },
};

export const DangerLevelBadge: React.FC<DangerLevelBadgeProps> = ({ level, size = 'small' }) => {
  const config = dangerLevelConfig[level];

  // Fallback to low if level is not found
  if (!config) {
    const fallbackConfig = dangerLevelConfig.low;
    return (
      <Chip
        label={fallbackConfig.label}
        color={fallbackConfig.color}
        size={size}
        icon={fallbackConfig.icon}
        sx={{
          'fontWeight': 600,
          'backgroundColor': fallbackConfig.bgcolor,
          'color': 'white',
          '& .MuiChip-icon': {
            color: 'white',
          },
        }}
      />
    );
  }

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={config.icon}
      sx={{
        'fontWeight': 600,
        'backgroundColor': config.bgcolor,
        'color': 'white',
        '& .MuiChip-icon': {
          color: 'white',
        },
      }}
    />
  );
};
